import { ReactNode } from "react";

import { HeaderTitle } from "@impero-com/common/components/applicationBar/headerTitle";
import { BreadcrumbSpec } from "@impero-com/common/componentTypes/breadcrumb";
import { setFlashRedirectToCurrentLocation } from "@impero-com/common/utils/flash";
import { Meta } from "@impero-com/common/utils/header";
import { t } from "@impero-com/common/utils/i18n";
import {
    ApplicationBarHeaderRow,
    ApplicationBarProfile,
    Button,
    Divider,
} from "@impero-com/ui";
import { Dropdown } from "antd";
import { Link } from "react-router-dom";

import { useOrgUserProfileCookie } from "utils/profileCookie";

import { useNewMenu } from "../../org/navigation/useNewMenu";
import { WebRoute } from "../../routes";
import { orgLogout } from "../../utils/logout";
import { useOrgDisplayInfo } from "../../utils/queries/useOrgDisplayInfoSuspenseQuery";

import * as theme from "./theme.css";

interface OrgProfileSectionProps {
    routerLinks?: boolean;
}
const OrgProfileSection = ({ routerLinks }: OrgProfileSectionProps) => {
    const orgDisplayInfo = useOrgDisplayInfo();
    const orgProfileCookie = useOrgUserProfileCookie();

    const handleLogin = () => {
        setFlashRedirectToCurrentLocation();
        window.location.assign("/");
    };
    const nbsp = "\xA0";
    const orgName = orgDisplayInfo.name.replace(/ /g, nbsp);
    if (!orgProfileCookie) {
        return (
            <ApplicationBarProfile
                organization={orgName}
                user={
                    <Button
                        id="login"
                        variant="link"
                        className={theme.logInButton}
                        onClick={handleLogin}
                    >
                        {t("Login_MenuTitle")}
                    </Button>
                }
                chevron={false}
            />
        );
    }

    const menuItems = [
        {
            key: 0,
            label:
                routerLinks === undefined || routerLinks ? (
                    <Link to={WebRoute.PROFILE}>{t("Menu_MyProfile")}</Link>
                ) : (
                    <a href={WebRoute.PROFILE}>{t("Menu_MyProfile")}</a>
                ),
        },
        {
            key: 1,
            label: (
                <Button
                    id="logout"
                    variant="link"
                    className={theme.menuButton}
                    onClick={orgLogout}
                >
                    {t("Logoff_MenuTitle")}
                </Button>
            ),
        },
    ];
    const { firstName, lastName } = orgProfileCookie;
    const userName = `${firstName} ${lastName}`.replace(/ +/g, nbsp);
    return (
        <Dropdown
            menu={{ items: menuItems }}
            trigger={["click"]}
            overlayClassName={theme.profileOpen}
        >
            <ApplicationBarProfile organization={orgName} user={userName} />
        </Dropdown>
    );
};

export interface ApplicationHeaderProps {
    title: string | BreadcrumbSpec;
    routerLinks?: boolean;
}

interface ApplicationHeaderWithLeadingProps extends ApplicationHeaderProps {
    leading?: ReactNode;
}
export const ApplicationHeader = ({
    title,
    routerLinks,
    leading,
}: ApplicationHeaderWithLeadingProps) => {
    const isStringTitle = typeof title === "string";
    const pageTitle = isStringTitle ? title : title.title;
    const newMenu = useNewMenu();

    return (
        <ApplicationBarHeaderRow>
            <Meta title={pageTitle} />
            <div className={theme.title}>
                {leading && (
                    <>
                        {leading}
                        <Divider
                            orientation="vertical"
                            spacing="small"
                            decorative
                            className={theme.leadingDivider}
                        />
                    </>
                )}
                <HeaderTitle
                    title={title}
                    rootPath={WebRoute.ROOT}
                    newMenu={newMenu}
                />
            </div>
            <OrgProfileSection routerLinks={routerLinks} />
        </ApplicationBarHeaderRow>
    );
};
